import './ColorPicker.scss'
import React, { Component } from 'react'
import { ChromePicker } from 'react-color'
import InputWrapper from './InputWrapper'
import TextInput from './TextInput'

class ColorPicker extends Component {
  constructor (props) {
    super(props)
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.state = { displayColorPicker: false }
  }

  handleOpen () {
    this.setState({ displayColorPicker: true })
  }

  handleClose () {
    this.setState({ displayColorPicker: false })
  }

  render () {
    return (
      <InputWrapper {...this.props} className='ColorPicker'>
        <TextInput {...this.props} onFocus={this.handleOpen} readOnly />
        <div className='ColorPicker_swatch' style={{ backgroundColor: this.props.value }} />
        {this.state.displayColorPicker &&
          <div className='ColorPicker_popover'>
            <div className='ColorPicker_cover' onClick={this.handleClose} />
            <ChromePicker
              onChangeComplete={(color) => this.props.onChange(color.hex)}
              color={this.props.value || undefined}
              disableAlpha
            />
          </div>
        }
      </InputWrapper>
    )
  }
}

ColorPicker.displayName = 'ColorPicker'

ColorPicker.defaultProps = {
  value: '#2a64f8'
}

export default ColorPicker



// WEBPACK FOOTER //
// ./src/lib/form/ColorPicker.js